import { useState, useRef, useEffect } from "react";
import sofar_battery_1 from "../../../assets/sofar_battery_1.png";
import sofar_battery_2 from "../../../assets/sofar_battery_2.png";
import sofar_battery_3 from "../../../assets/sofar_battery_3.png";
import "../KeyBenefits.css";
import triangle_yellow from "../../../assets/triangle_yellow.png";

const features = [
  { title: "Advanced safety architecture", description: "5-stage protection with LiFePO4 technology and full temperature monitoring for safe, reliable operation." },
  { title: "Smart battery management (BMS)", description: "Intelligent control with auto SOC calibration, active balancing, and remote monitoring." },
  { title: "Ultra-low self-consumption", description: "Low standby and sleep losses to maximise usable stored energy." },
  { title: "Modular & flexible expansion", description: "Scalable design allows additional battery modules as your energy needs grow." },
  { title: "Quiet & user-friendly design", description: "Low-noise natural cooling with LCD display and app monitoring." },
  { title: "Fast backup response (EPS)", description: "Automatic switchover with strong surge support for essential household loads." },
];

const images = [sofar_battery_1, sofar_battery_2, sofar_battery_3];

export default function KeyBenefits() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => setInView(e.isIntersecting),
      { threshold: 0.2 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`benefits-proven-brands-section ${inView ? "benefits-in-view" : ""}`}>
      <div className="benefits-brands-content">
        <div className="benefits-image-and-dots">
          <div className="benefits-image-row">
            <img key={activeIndex} src={images[activeIndex]} alt="SOFAR product" className="benefits-brands-image" />
          </div>
          <div className="benefits-dots">
            {[0, 1, 2].map((i) => (
              <button
                key={i}
                type="button"
                className={`benefits-dot ${i === activeIndex ? "active" : ""}`}
                onClick={() => setActiveIndex(i)}
                aria-label={`Show image ${i + 1}`}
                aria-pressed={i === activeIndex}
              />
            ))}
          </div>
        </div>
        <div className="benefits-brands-info-card">
          <h2>Key Benefits & Features</h2>
          {features.map((f, i) => (
            <div key={i} className="benefits-feature-row">
              <div className="benefits-feature-icon">
                <img src={triangle_yellow} alt="" className="arrow-icon" />
              </div>
              <div className="benefits-feature-text">
                <h3>{f.title}</h3>
                <p>{f.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
